import { VisitAgeState, VisitBrowseMode, VisitBrowseRow, VisitContentSource, visitDisplayStatus } from '@jms/model';

/** Visit host context shared by surfaces and the expand command. */

export interface VisitSurfaceParams {
  servicePlanId?: string;
  /** Carries an explicit host lock through Expand into the Manage inspector. */
  hostReadonly?: boolean;
}

export interface VisitSurfaceContext {
  fromServicePlan: boolean;
  hostReadonly: boolean;
}

/** Signal forms treat missing/undefined as "no field". Keep optional lookups as null so `job` stays on the tree. */
export function visitSurfaceModel(record: VisitBrowseRow): VisitBrowseRow {

  return {
    ...record,
    // Board cards use the line name; this inspector title is the entity so the screen is not mistaken for a line.
    name: 'Visit',
    displayStatus: visitDisplayStatus(record),
    datesOverridden: record.datesOverridden ?? false,
    approval: record.approval ?? null,
    approvedBy: record.approvedBy ?? null,
    job: record.job ?? null,
    // A read that predates the age fields is Current: never guess a Visit late.
    ageState: record.ageState ?? VisitAgeState.Current,
    lineOwner: record.lineOwner?._id ? record.lineOwner : null,
    site: record.site ?? null,
    customer: record.customer ?? null,
    servicePlan: record.servicePlan ?? null,
    serviceLine: record.serviceLine ?? null,
    contractor: record.contractor?._id ? record.contractor : null,
    resources: (record.resources ?? []).filter(resource => !!resource?._id),
  } as VisitBrowseRow;
}

/** Operational projections remain editable unless the enclosing host explicitly locks this Visit. */
export function visitSurfaceReadonly(record: VisitBrowseRow, hostReadonly = false): boolean {

  if (hostReadonly) return true;
  if (record.job?._id) return true;
  if (record.active === false) return true;
  if (record.mode === VisitBrowseMode.PlanPreview) return true;
  if (record.contentSource === VisitContentSource.Snapshot) return true;
  const status = record.status;
  return status === 'Skipped';
}
